// NOTE
// Typography systems are not finalized yet per Kimi.
// This is all subject to change as
import { css } from 'styled-components'

import { cta_buttonPrimaryBackground, grey700 } from './colors'

export const font_size_xs = '10px'
export const font_size_sm = '12px'
export const font_size_md = '14px'
export const font_size_lg = '16px'
export const font_size_xl = '18px'
export const font_size_2xl = '20px'
export const font_size_3xl = '24px'
export const font_size_4xl = '32px'
export const font_size_5xl = '48px'

// NOTE
// Figma designs call for "regular" "medium" "semibold" "bold"
// I only see these 3 font faces in the codebase and nothing else

// TODO: Align on what is in the codebase and what's defined in the Figma Design System

export const font_family_weight_regular = 'Rubik-Regular'
export const font_family_weight_medium = 'Rubik-Medium'
export const font_family_weight_semibold = 'Rubik-Semibold'
// export const font_family_weight_bold = 'Rubik-Bold' // in design and not codebase
export const font_family_weight_mediumItalic = 'Rubik-MediumItalic'
export const font_family_weight_italic = 'Rubik-Italic'

export const font_xs = css`
  font-size: ${font_size_xs};
  line-height: 14px;
`
export const font_sm = css`
  font-size: ${font_size_sm};
  line-height: 16px;
`

export const font_md = css`
  font-size: ${font_size_md};
  line-height: 18px;
`

export const font_lg = css`
  font-size: ${font_size_lg};
  line-height: 20px;
`

export const font_xl = css`
  font-size: ${font_size_xl};
  line-height: 22px;
`

export const font_2xl = css`
  font-size: ${font_size_2xl};
  line-height: 24px;
`

export const font_3xl = css`
  font-size: ${font_size_3xl};
  line-height: 28px;
`

export const font_4xl = css`
  font-size: ${font_size_4xl};
  line-height: 36px;
`

export const font_5xl = css`
  font-size: ${font_size_5xl};
  line-height: 48px;
`

export const fontH1 = css`
  font-family: ${font_family_weight_medium};
  ${font_5xl};
`
export const fontH2 = css`
  font-family: ${font_family_weight_medium};
  font-size: ${font_size_4xl};
  line-height: 36px;
`

export const fontH3 = css`
  font-family: ${font_family_weight_medium};
  font-size: ${font_size_2xl};
  line-height: 24px;
`

export const fontRegular = css`
  font-family: ${font_family_weight_regular};
  font-size: ${font_size_lg};
  line-height: 20px;
`

export const fontLinkText = css`
  color: ${cta_buttonPrimaryBackground};
  font-size: ${font_size_sm};
  line-height: 18px;
  font-weight: bold;
  &:hover {
    cursor: pointer;
  }
`

export const fontBold = css`
  font-family: ${font_family_weight_medium};
  font-size: ${font_size_lg};
  line-height: 20px;
`

export const fontFormLabel = css`
  font-family: ${font_family_weight_regular};
  font-size: ${font_size_md};
  line-height: 18px;
  color: ${grey700};
`

export const fontSupportMedium = css`
  font-family: ${font_family_weight_regular};
  font-weight: 500;
  font-size: ${font_size_md};
  line-height: 18px;
  color: ${grey700};
`
